// Auto-generated by scripts/generate_daily_seo_content.js
// Do not edit this file manually.

const dailySeoContent = {
  "updatedAt": "2026-05-16",
  "topic": "德州扑克基础玩法 / 德扑怎么打 / 德扑规则介绍",
  "metaKeywords": "德州扑克基础玩法, 德扑怎么打, 德扑规则介绍, 德扑新手学什么, 德州扑克起手牌技巧, 德扑诈唬技巧, 德州扑克比赛规则, 德扑术语大全, hhpoker怎么玩, hhpoker德州规则",
  "focusKeywords": [
    {
      "keyword": "德州扑克基础玩法",
      "path": "/guide",
      "anchorText": "德州扑克基础玩法"
    },
    {
      "keyword": "德扑怎么打",
      "path": "/guide",
      "anchorText": "德扑怎么打入口"
    },
    {
      "keyword": "德扑规则介绍",
      "path": "/texas-poker-complete-guide",
      "anchorText": "德扑规则介绍攻略"
    },
    {
      "keyword": "德扑新手学什么",
      "path": "/guide",
      "anchorText": "德扑新手学什么"
    },
    {
      "keyword": "德州扑克起手牌技巧",
      "path": "/texas-poker-complete-guide",
      "anchorText": "德州扑克起手牌技巧入口"
    },
    {
      "keyword": "德扑诈唬技巧",
      "path": "/guide",
      "anchorText": "德扑诈唬技巧教程"
    },
    {
      "keyword": "德州扑克比赛规则",
      "path": "/texas-poker-complete-guide",
      "anchorText": "德州扑克比赛规则"
    },
    {
      "keyword": "德扑术语大全",
      "path": "/guide",
      "anchorText": "德扑术语大全入口"
    },
    {
      "keyword": "hhpoker怎么玩",
      "path": "/guide",
      "anchorText": "hhpoker怎么玩教程"
    },
    {
      "keyword": "hhpoker德州规则",
      "path": "/texas-poker-complete-guide",
      "anchorText": "hhpoker德州规则"
    }
  ],
  "faqEntries": [
    {
      "name": "德州扑克基础玩法 怎么操作更稳妥？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议先访问对应专题页查看完整步骤，再结合设备系统和当前版本执行，可明显减少重复排障时间。关键词：德州扑克基础玩法。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德扑怎么打 怎么操作更稳妥？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议先访问对应专题页查看完整步骤，再结合设备系统和当前版本执行，可明显减少重复排障时间。关键词：德扑怎么打。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德扑规则介绍 怎么操作更稳妥？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议先访问对应专题页查看完整步骤，再结合设备系统和当前版本执行，可明显减少重复排障时间。关键词：德扑规则介绍。"
      },
      "linkPath": "/texas-poker-complete-guide"
    },
    {
      "name": "德扑新手学什么 怎么操作更稳妥？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议先访问对应专题页查看完整步骤，再结合设备系统和当前版本执行，可明显减少重复排障时间。关键词：德扑新手学什么。"
      },
      "linkPath": "/guide"
    }
  ]
};

export default dailySeoContent;
